import { Button } from "@accurx/design";
import styled from "styled-components";

// A Button that takes all width available and centers its children
export const StyledFullWidthButton = styled(Button)`
    width: 100%;
    display: flex;
    justify-content: center;
`;
